<microsec-loading-overlay [isLoading]="!!isLoading">
  <div class="form no-wrapper">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mb-6">
        <div class="flex items-center gap-2">
          <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
            <p-button
              type="button"
              severity="success"
              size="small"
              label="Assign Firmware"
              [disabled]="!isValidLicense()"
              (onClick)="openAssignFirmwareForm()" />
          </div>
          <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
            <p-button
              *ngIf="deviceFirmware?.target_device === 'hikvision_cctv'"
              type="button"
              label="Push Firmware"
              severity="info"
              size="small"
              [disabled]="!isValidLicense()"
              (onClick)="openFirmwarePushForm()" />
          </div>
        </div>
      </div>
      <div class="col-span-12">
        <div class="field grid grid-cols-12 gap-4">
          <label class="col-span-12 md:col-span-4">Current Firmware Version</label>
          <label class="col-span-12 md:col-span-8">{{ deviceFirmware?.current_version || '-' }}</label>
        </div>
        <div class="field grid grid-cols-12 gap-4 items-center">
          <label class="col-span-12 md:col-span-4">Assigned Firmware Version</label>
          <label class="col-span-12 md:col-span-8">{{ deviceFirmware?.version || '-' }}</label>
        </div>
        <div class="field grid grid-cols-12 gap-4 items-center">
          <label class="col-span-12 md:col-span-4">Status</label>
          <label class="col-span-12 md:col-span-8">{{ (deviceFirmware?.status | constant: 'firmware-device-status') || '-' }}</label>
        </div>
      </div>
    </div>

    <p-divider />

    <div class="grid grid-cols-12 gap-4">
      <label class="col-span-12 font-bold">Available Firmware Versions</label>
      <div class="col-span-12">
        <microsec-card [isNestedCard]="true" [isTableCard]="true">
          <microsec-common-table
            [cols]="cols"
            [values]="firmwares"
            [loading]="isLoading"
            [scrollHeight]="'40rem'"
            [cellTemplate]="cellTemplate"
            [actionsMenuItems]="actionsMenuItems">
          </microsec-common-table>
        </microsec-card>
      </div>
      <div class="col-span-12">
        <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="right" appendTo="body">
          <p-button
            type="button"
            label="Upload Firmware"
            severity="info"
            [disabled]="!isValidLicense()"
            (onClick)="openUploadFirmwareForm()"
            *ngIf="!!permissions[USER_ROLE.ADMIN]" />
        </span>
      </div>
    </div>
  </div>
</microsec-loading-overlay>

<ng-template let-col="col" let-rowData="rowData" #cellTemplate>
  <ng-container [ngSwitch]="col.field">
    <!-- Type -->
    <ng-container *ngSwitchCase="'target_device'">
      <label>
        {{ (rowData[col.field] | constant: 'firmware-target-device') || '-' }}
      </label>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="overflow-hidden whitespace-nowrap text-ellipsis">
        {{ rowData[col.field] || '-' }}
      </div>
    </ng-container>
  </ng-container>
</ng-template>
